import React, { useEffect } from 'react';
import { TextField, Autocomplete, Button, IconButton } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import EditVariables from './EditVariables';

const ManageSubConditions = () => {
  const dispatch = useDispatch();
  const { condition_id } = useParams();

  const { condition } = useSelector((state) => state.general);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: `conditions/getConditionById`,
        conditionId: condition_id,
      })
    );
  }, []);
  if (condition?._id !== condition_id) {
    dispatch(
      generalSet({
        reduxField: 'condition',
        value: null,
      })
    );
  }

  return condition?._id ? (
    <>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>Sub Conditions</h1>
        </div>
      </div>
      <EditVariables condition={condition} />
    </>
  ) : (
    <Spinner />
  );
};

export default ManageSubConditions;
